import React from "react";
import { calculateCashout } from "../../utils/cashoutUtils";
import "./Cashout.css";

/**
 * CashoutButton Component
 * 
 * Displays the green "Cashout" button on the market header.
 * When clicked, triggers the Cashout calculation and opens the bet slip.
 */
const CashoutButton = ({
  marketId,
  eventDetail,
  updatedAllRunners,
  eventLock,
  onCashoutClick,
}) => {
  const cashoutData = calculateCashout(marketId, {
    eventDetail,
    updatedAllRunners,
    eventLock,
  });

  const handleClick = (e) => {
    e.stopPropagation();
    if (cashoutData && onCashoutClick) {
      onCashoutClick(cashoutData);
    }
  };

  return (
    <button
      type="button"
      className="btn cashout-btn"
      onClick={handleClick}
      disabled={!cashoutData}
      title={
        cashoutData
          ? `Cashout available: ${cashoutData.betType} @ ${cashoutData.odds}`
          : "Cashout currently unavailable"
      }
    >
      Cashout
    </button>
  );
};

export default CashoutButton;
